<div class="flex justify-end" *ngIf="showFilter$ | async">
    <button
        app-round-button
        class="filter-button mat-badge-more-overlay"
        matTooltip="Filter"
        [matBadge]="filterAmount$ | async"
        [matBadgeHidden]="!(filterAmount$ | async)"
        [matBadgeOverlap]="true"
        (click)="filter.Toggle(); $event.stopPropagation()"
    >
        <fa-icon icon="filter"></fa-icon>
    </button>
</div>
<app-filter-card UnlimitedHeight MaxWidthHundertPercent #filter [Settings]="filterSettings$ | async" [Values]="filterValues$ | async" (ValuesChange)="setFilterValues($event)"></app-filter-card>
<mat-progress-bar mode="indeterminate" *ngIf="dataSource.loading$ | async"></mat-progress-bar>
    <table mat-table class="full-width-table" matSort aria-label="Elements" [matSortActive]="'ConsolidatedDate'" [matSortDirection]="'desc'">
        <ng-container [matColumnDef]="colName" *ngFor="let colName of autoDisplayedColumns">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ columnHeaders[colName] }}</th>
            <td mat-cell *matCellDef="let row">{{ row[colName] }}</td>
        </ng-container>
        <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox *ngIf="multiple$ | async" [checked]="dataSource.allSelected$ | async" [indeterminate]="dataSource.someSelected$ | async" (change)="selectAll($event.checked)"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox [disabled]="(disableUncheckedCheckboxes$ | async) && !(row.isSelected$ | async)" (click)="$event.stopPropagation()" [checked]="row.isSelected$ | async" (change)="toggleSelection(row.Id)"></mat-checkbox>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="clickable-mat-row" (click)="toggleSelection(row.Id)"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell empty-table-text" [attr.colspan]="displayedColumns.length">
                {{ emptyText }}
            </td>
        </tr>
    </table>

    <mat-paginator #paginator [length]="dataSource?.length$ | async" [pageIndex]="0" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" aria-label="Select page"> </mat-paginator>
